<template>
    <div>
        <UiCardListHeader
            :title="lang('logging::activity.widgets.latest_activity.title')"
            :action-href="canViewFullLog ? route('logging.admin.activity.tail') : undefined"
            :action-label="canViewFullLog ? lang('logging::activity.actions.show') : undefined"
        />

        <UiCardEmpty v-if="activities.length === 0">
            {{ lang('logging::activity.widgets.latest_activity.no_activity') }}
        </UiCardEmpty>
        <transition-group
            v-else
            tag="div"
            class="activity-list"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <activity-preview v-for="activity in activities" :key="activity.id" :log="activity" />
        </transition-group>
    </div>
</template>

<script setup lang="ts">
import { ref, Ref } from 'vue';
import ActivityPreview from '@src/Logging/Pages/Activity/Partials/ActivityPreview.vue';
import { LogActivity } from '@src/Logging/Pages/types';

interface WidgetData {
    activities?: LogActivity[];
    canViewFullLog?: boolean;
}

const props = defineProps<{ slug?: string; settings?: object; data?: WidgetData }>();

const activities: Ref<LogActivity[]> = ref(props.data?.activities ?? []);
const canViewFullLog = ref(props.data?.canViewFullLog ?? false);
</script>
